import type { MenuProps } from "antd";
import { Col, Dropdown, Row } from "antd";
import React, { useEffect } from "react";
import { TfiArrowCircleDown } from "react-icons/tfi";
import { LOCAL_IMAGE } from "../../../assets/images/ImagesJson";
import { getUserCookie } from "../../../utils/helperFunctions/getCookie";
import {
  capitalizeWords,
  logout,
  toPascalCase,
} from "../../../utils/helperFunctions/numberFormatter";
import { FiMenu } from "react-icons/fi";
import "./navbar.scss";

interface HeaderProps {
  setMobileSideBar: (value: boolean) => void;
  mobileSideBar: boolean;
}

const MainNavbar = ({ setMobileSideBar, mobileSideBar }: HeaderProps) => {
  const { User_type, user_name } = getUserCookie();

  const items: MenuProps["items"] = [
    // {
    //   key: "1",
    //   label: (
    //     <p>
    //       {capitalizeWords(user_name)}
    //       {"  "}
    //     </p>
    //   ),
    // },
    {
      key: "1",
      label: <a onClick={() => logout()}>Logout</a>,
    },
  ];

  return (
    <>
      <Row className="bg-navbar navbar-bg">
        <Col xs={12} sm={12} lg={0}>
          <div className="flex justify-start items-center w-full h-16">
            <div className="flex flex-row ps-4">
              <FiMenu
                className="cursor-pointer"
                size={22}
                onClick={() => setMobileSideBar(!mobileSideBar)}
              />
            </div>
          </div>
        </Col>
        <Col xs={12} sm={12} lg={24}>
          <div className="flex justify-end items-center w-full h-16">
            <div className="flex items-center pe-4">
              <div className="items-center pe-2">
                <img src={LOCAL_IMAGE.userIcon} className="h-8 w-8" />
              </div>
              <div className="items-center">
                <div className="text-sm font-medium">{user_name}</div>
                {/* <div className="text-xs">
                  {capitalizeWords(User_type.replaceAll("_", " "))}
                </div> */}
              </div>
              <div className="flex items-center px-2">
                <Dropdown
                  menu={{ items }}
                  placement="bottomRight"
                  className="cursor-pointer"
                  trigger={["click"]}
                  arrow
                >
                  <TfiArrowCircleDown className="text-xl" />
                </Dropdown>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default MainNavbar;
